import PollsSettingsPage from './PollsSettingsPage';

export const components = {
  PollsSettingsPage,
};
